//import SendOrderMessagePopup from "@/pages/comp/book_order/shop/order/popup/send_order_msg";
import SendOrderMessageArea from "@/pages/comp/book_order/shop/order/acommon/send_order_msg";

function SendOrderMessagePopup(props: any) {
  let myProps = {
    closePopup: () => { },
    refreshData: (inData: any) => { },
    callbackData: (inData: any) => { },
    order_seq_arr: [],
    msg_sort: "order_start_deliver",//order_start_deliver, order_notice
    ...props
  };

  return (
    <div>
      <SendOrderMessageArea
        closePopup={myProps.closePopup}
        refreshData={myProps.refreshData}
        callbackData={myProps.callbackData}
        order_seq_arr={myProps.order_seq_arr}
        msg_sort={myProps.msg_sort}
      ></SendOrderMessageArea>
    </div>
  );
};
export default SendOrderMessagePopup;